export default __webpack_public_path__ + "static/media/graph.07ce1293.png";